import { AlertTriangle } from "lucide-react";
import { SOURCES } from "@/data/sources";

export function FentanylWarnings() {
  return (
    <div
      role="alert"
      className="glass-card"
      style={{
        padding: "clamp(0.85rem, 3vw, 1.25rem) clamp(0.85rem, 3vw, 1.5rem)",
        marginBottom: "1.5rem",
        border: "1px solid rgba(248,113,113,0.5)",
        background:
          "linear-gradient(135deg, rgba(248,113,113,0.08), rgba(251,146,60,0.05))",
        display: "flex",
        gap: "clamp(0.6rem, 2vw, 1rem)",
        alignItems: "flex-start",
      }}
    >
      <AlertTriangle
        size={22}
        style={{ color: "#f87171", flexShrink: 0, marginTop: 2 }}
      />
      <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
        <strong style={{ color: "#fca5a5", fontSize: "0.95rem" }}>
          Fentanyl, spezielle Warnhinweise
        </strong>
        <p style={{ color: "var(--text-primary)", fontSize: "0.88rem", lineHeight: 1.55, margin: 0 }}>
          <strong style={{ color: "#fca5a5" }}>Extreme Potenz:</strong>{" "}
          Ca. 100x stärker als Morphin, kleinste Dosisfehler können tödlich sein.
          Einheiten nicht vermischen: i.v. in mg/µg als Einzeldosis, transdermal als Freisetzungsrate µg/h.
        </p>
        <p style={{ color: "var(--text-primary)", fontSize: "0.88rem", lineHeight: 1.55, margin: 0 }}>
          <strong style={{ color: "#fca5a5" }}>Transdermales Depot:</strong>{" "}
          Das Pflaster bildet ein Hautdepot. Nach dem Entfernen wird weiter Fentanyl aus
          der Haut aufgenommen; der Serumspiegel sinkt im Mittel erst nach etwa 20–27 h
          um 50 %. Wirkung und Atemdepression können deshalb stundenlang anhalten.
          Äußere Wärme (z. B. Heizdecke, Sauna) kann die Aufnahme deutlich erhöhen und
          tödliche Überdosierungen verursachen; direkte Wärme am Pflaster und seiner
          Umgebung vermeiden. Auch Fieber kann den Fentanylspiegel erhöhen und erfordert
          ärztliche Überwachung auf Sedierung und Atemdepression.{" "}
          <a
            href={SOURCES["dailymed-fentanyl-system-2026"].url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--accent)", textDecoration: "underline" }}
          >
            Quelle: Fentanyl System, US-Fachinformation, Abschnitte 5.8, 5.9, 10 und 12.3
          </a>
          {" "}(Stand 03/2026; geprüft am 07.10.2026).
        </p>
        <p style={{ color: "var(--text-primary)", fontSize: "0.88rem", lineHeight: 1.55, margin: 0 }}>
          <strong style={{ color: "#fca5a5" }}>Fentanyl in Europa:</strong>{" "}
          Laut European Drug Report 2026 ist die geografische Verbreitung bislang auf wenige
          Länder konzentriert. Für Deutschland nennt die EUDA 95 fentanylbezogene Todesfälle
          im Jahr 2024. Ein Teil könnte mit abgezweigten Fentanyl-Arzneimitteln statt illegal
          produziertem Fentanyl zusammenhängen.
        </p>
        <p style={{ color: "var(--text-primary)", fontSize: "0.88rem", lineHeight: 1.55, margin: 0 }}>
          <strong style={{ color: "#fca5a5" }}>Nitazene und Orphine:</strong>{" "}
          Die EUDA berichtet zunehmend über gefälschte Arzneimittel mit Nitazenen, etwa als
          Oxycodon oder Benzodiazepine angebotene Tabletten. Auch neuere Orphine wurden in
          Europa mit Vergiftungen und Todesfällen in Verbindung gebracht. Diese Entwicklungen
          sind ein wachsendes Risiko, aber kein Beleg für eine europaweite Dominanz bei Überdosierungen.
          Ohne Analytik ist der Gehalt nicht abschätzbar; Drug-Checking und
          Naloxon-Verfügbarkeit sind entscheidend.
        </p>
      </div>
    </div>
  );
}
